<template>
  <div class="text-center">
    <h1 class="mb-4 mx-5"><icon icon="exclamation-circle" class="text-danger mr-2" /></h1>
    <h2 class="mb-5 mx-5">{{title}}</h2>
    <p>{{body}}</p>
    <div v-if="reference">
      <p>If you would like to query this outcome, please reference policy:</p>
      <p class="justify-content-center text-center font-weight-bold mb-3 mt-4">{{reference}}</p>
    </div>
  </div>
</template>
<script>
export default { props: ['title', 'body', 'reference'] }
</script>
